export const getHeadersConfig = (authorizationHeader, acceptHeader) => {
  const headers = {};

  const config = {
    responseType: 'arraybuffer'
  };

  if (authorizationHeader) {
    Object.assign(headers, { Authorization: authorizationHeader });
  }
  if (acceptHeader) {
    Object.assign(headers, { Accept: acceptHeader });
  }

  if (Object.keys(headers).length > 0) {
    Object.assign(config, { headers });
  }

  return config;
};
